$(function() {


    $('input[name=search_needle]').on('keyup', function(e){
        if(e.keyCode == 13){
            Manogi.startSearch($(this).closest('.js-search'));
        }
    });

    $('.js-search .js-button').on('click', function(){
         Manogi.startSearch($(this).closest('.js-search'));
    });


});
